import React from "react";

function Fax() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v7h19v-7c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm11 11H5v-5c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v5zm-2-4h-4v2h4v-2z" />
    </svg>
  );
}

export default Fax;
